import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import image from './image.png';
import {Promo} from '../../blocks';

/**
 *  AnimationSample
 */
class AnimationSample extends PureComponent {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      currentContentId: 'content01',
      isOpened: false,
      currentSlickDotId: 'dot01',
    }
  }
  
  componentDidMount() {
  };
  
  componentWillUnmount() {
  };
  
  render() {
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
      >
        <div className="AnimationSample">
          <h1 className="AnimationSample__heading">Animation Sample</h1>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Text Link</h2>
            <h3 className="AnimationSample__heading3">TextLinkBlack</h3>
            <div className="AnimationSample__box-white">
              {this.renderTextLinkBlack()}
            </div>
            <h3 className="AnimationSample__heading3">TextLinkBlack current</h3>
            <div className="AnimationSample__box-white">
              {this.renderTextLinkBlack_current()}
            </div>
            <h3 className="AnimationSample__heading3">TextLinkWhite</h3>
            <div className="AnimationSample__box-black">
              {this.renderTextLinkWhite()}
            </div>
            <h3 className="AnimationSample__heading3">TextLinkWhite current</h3>
            <div className="AnimationSample__box-black">
              {this.renderTextLinkWhite_current()}
            </div>
          </section>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Button</h2>
            <h3 className="AnimationSample__heading3">ButtonStandardBlack</h3>
            <div className="AnimationSample__box-white">
              {this.renderButtonStandardBlack()}
            </div>
            <h3 className="AnimationSample__heading3">ButtonStandardWhite</h3>
            <div className="AnimationSample__box-black">
              {this.renderButtonStandardWhite()}
            </div>
            <h3 className="AnimationSample__heading3">ButtonActionBlack</h3>
            <div className="AnimationSample__box-white">
              {this.renderButtonActionBlack()}
            </div>
            <h3 className="AnimationSample__heading3">ButtonActionWhite</h3>
            <div className="AnimationSample__box-black">
              {this.renderButtonActionWhite()}
            </div>
          </section>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Image Link</h2>
            <h3 className="AnimationSample__heading3">ImageLinkWhite</h3>
            <div className="AnimationSample__box2-white">
              {this.renderImageLinkWhite()}
            </div>
            <h3 className="AnimationSample__heading3">ImageLinkWhite current</h3>
            <div className="AnimationSample__box2-white">
              {this.renderImageLinkWhite_current()}
            </div>
            <h3 className="AnimationSample__heading3">ImageLinkBlack</h3>
            <div className="AnimationSample__box2-black">
              {this.renderImageLinkBlack()}
            </div>
            <h3 className="AnimationSample__heading3">ImageLinkBlack current</h3>
            <div className="AnimationSample__box2-black">
              {this.renderImageLinkBlack_current()}
            </div>
          </section>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Toggle Contents</h2>
            <h3 className="AnimationSample__heading3">ToggleContents</h3>
            <div className="AnimationSample__box-white">
              {this.renderToggleContents()}
            </div>
          
          </section>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Link Arrow Icon</h2>
            <h3 className="AnimationSample__heading3">LinkArrowIcon</h3>
            <div className="AnimationSample__box-white">
              {this.renderLinkArrowIcon()}
            </div>
          </section>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Pull Down</h2>
            <h3 className="AnimationSample__heading3">PullDown</h3>
            <div className="AnimationSample__box-white">
              {this.renderPullDown()}
            </div>
          </section>
          
          <section className="AnimationSample__section">
            <h2 className="AnimationSample__heading2">▼ Slick Dots</h2>
            <div className="AnimationSample__box-white">
              {this.renderSlickDots()}
            </div>
          </section>
          
          {/*<section className="AnimationSample__section">*/}
          {/*<h2 className="AnimationSample__heading2">▼ Close Modal Link</h2>*/}
          {/*</section>*/}
        
        </div>
      </Wrapper>
    )
  }
  
  // TextLinkBlack
  renderTextLinkBlack = () => {
    return (
      <a className="TextLinkBlack" href="">下線付きのテキストリンク</a>
    )
  };
  renderTextLinkBlack_current = () => {
    return (
      <a className="TextLinkBlack current" href="">下線付きのテキストリンク カレント状態</a>
    )
  };
  
  // TextLinkWhite
  renderTextLinkWhite = () => {
    return (
      <a className="TextLinkWhite" href="">下線付きのテキストリンク</a>
    )
  };
  renderTextLinkWhite_current = () => {
    return (
      <a className="TextLinkWhite current" href="">下線付きのテキストリンク カレント状態</a>
    )
  };
  
  // ButtonStandardBlack
  renderButtonStandardBlack = () => {
    return (
      <a className="ButtonStandardBlack" href="">
        <span className="ButtonStandardBlack__text">ボタンリンク</span>
      </a>
    )
  };
  
  // ButtonStandardWhite
  renderButtonStandardWhite = () => {
    return (
      <a className="ButtonStandardWhite" href="">
        <span className="ButtonStandardWhite__text">ボタンリンク</span>
      </a>
    )
  };
  
  // ButtonActionBlack
  renderButtonActionBlack = () => {
    return (
      <a className="ButtonActionBlack" href="">
        <span className="ButtonActionBlack__text">ボタンリンク</span>
      </a>
    )
  };
  
  // ButtonActionWhite
  renderButtonActionWhite = () => {
    return (
      <a className="ButtonActionWhite" href="">
        <span className="ButtonActionWhite__text">ボタンリンク</span>
      </a>
    )
  };
  
  // ImageLinkWhite
  renderImageLinkWhite = () => {
    return (
      <a className="ImageLinkWhite" href="">
        <div className="ImageLinkWhite__container">
          <img className="ImageLinkWhite__image" src={image}/>
        </div>
        下線付きの画像有りリンク
      </a>
    )
  };
  renderImageLinkWhite_current = () => {
    return (
      <a className="ImageLinkWhite current" href="">
        <div className="ImageLinkWhite__container">
          <img className="ImageLinkWhite__image" src={image}/>
        </div>
        下線付きの画像有りリンク カレント状態
      </a>
    )
  };
  
  // ImageLinkBlack
  renderImageLinkBlack = () => {
    return (
      <a className="ImageLinkBlack" href="">
        <div className="ImageLinkBlack__container">
          <img className="ImageLinkBlack__image" src={image}/>
        </div>
        下線付きの画像有りリンク
      </a>
    )
  };
  renderImageLinkBlack_current = () => {
    return (
      <a className="ImageLinkBlack current" href="">
        <div className="ImageLinkBlack__container">
          <img className="ImageLinkBlack__image" src={image}/>
        </div>
        下線付きの画像有りリンク カレント状態
      </a>
    )
  };
  
  // Toggle Contents
  renderToggleContents = () => {
    return (
      <div className="ToggleContents">
        <ul className="ToggleContents__list-nav">
          <li>
            <a className={'TextLinkBlack' + ((this.state.currentContentId === 'content01') ? ' current': '')}
               href="javascript:void(0)"
               onClick={(e) => {
                 e.preventDefault();
                 this.setState({
                   currentContentId: 'content01',
                 });
               }}
            >コンテンツ 01</a>
          </li>
          <li>
            <a className={'TextLinkBlack' + ((this.state.currentContentId === 'content02') ? ' current': '')}
               href="javascript:void(0)"
               onClick={(e) => {
                 e.preventDefault();
                 this.setState({
                   currentContentId: 'content02',
                 });
               }}
            >コンテンツ 02</a>
          </li>
        </ul>
        <div className={'ToggleContents__content' + ((this.state.currentContentId === 'content01') ? ' open': '')}>
          <ul className="ToggleContents__list-contents">
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 1-1</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 1-2</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 1-3</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
          </ul>
        </div>
        <div className={'ToggleContents__content' + ((this.state.currentContentId === 'content02') ? ' open': '')}>
          <ul className="ToggleContents__list-contents multiple-lines">
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 2-1</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 2-2</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 2-3</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 2-4</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 2-5</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
            <li>
              <Promo{...{
                pcDescription: '<p>Promoブロック 2-6</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false,
                },
                pcLayout: 'Image-On-Top',
              }}/>
            </li>
          </ul>
        </div>
      </div>
    )
  };
  
  // Link Arrow Icon
  renderLinkArrowIcon = () => {
    return (
      <a className={'LinkArrowIcon' + ((this.state.isOpened) ? ' open': '')}
         href="javascript:void(0)"
         onClick={(e) => {
           e.preventDefault();
           this.setState({
             isOpened: !this.state.isOpened,
           });
         }}
      >開く・閉じるリンク</a>
    )
  };
  
  // Pull Down
  renderPullDown = () => {
    return (
      <div>
        <a className={'LinkArrowIcon' + ((this.state.isOpened2) ? ' open': '')}
           href="javascript:void(0)"
           onClick={(e) => {
             e.preventDefault();
             this.setState({
               isOpened2: !this.state.isOpened2,
             });
           }}
        >開く・閉じるリンク</a>
        <div className={'PullDown' + ((this.state.isOpened2) ? ' open': '')}>
          <div className="PullDown__container"
               style={(this.state.isOpened2) ? {height: this.refs.contents.clientHeight}: null}
               onTransitionEnd={(e) => {
                 e.currentTarget.style.height = 'auto';
               }}
          >
            <div className="PullDown__contents" ref="contents">
              プルダウンコンテンツ<br/>
              プルダウンコンテンツ<br/>
              プルダウンコンテンツ<br/>
              プルダウンコンテンツ<br/>
              プルダウンコンテンツ<br/>
              プルダウンコンテンツ<br/>
            </div>
          </div>
        </div>
      </div>
    )
  };
  
  // Slick Dots
  renderSlickDots = () => {
    const arr = ['dot01', 'dot02', 'dot03', 'dot04', 'dot05'];
    return (
      <ul className="slick-dots">
        {arr.map((id, index) => {
          if (id === this.state.currentSlickDotId) {
            return (
              <li className="slick-active">
                <button onClick={(e)=> {
                  e.preventDefault();
                  this.setState({
                    currentSlickDotId: id
                  })
                }}/>
              </li>
            )
          } else {
            return (
              <li>
                <button onClick={(e)=> {
                  e.preventDefault();
                  this.setState({
                    currentSlickDotId: id
                  })
                }}/>
              </li>
            )
          }
        })}
      </ul>
    )
  }
  
}

export default AnimationSample;




// WEBPACK FOOTER //
// ./src/containers/animation-sample/index.jsx